// ============================================================================
// dataTypes/liveStreamManagment/sourceRegistry/acquirers/FinalAcquirer.ts
// Gère la source synthétique "final" : le flux du canvas de compositing
// (ce que la régie a actuellement à l'antenne, overlays compris).
//
// Comme RemoteAcquirer, le stream n'est PAS acquis par l'acquirer lui-même.
// C'est useCanvasPipeline (publishCanvasStream / initCanvasStream) qui le
// produit et l'injecte via registry.injectStream('final', stream) à chaque
// publication du canvas.
//
// acquire() ici attend simplement que le stream soit injecté — utile quand
// une scène emprunte "final" après un refCount retombé à 0 (registry remis à
// idle entre-temps) mais avant la prochaine publication du canvas.
// ============================================================================

import { Source, SourceAcquirer } from '../types';

export class FinalAcquirer implements SourceAcquirer {

  async acquire(source: Source): Promise<MediaStream> {
    if (source.stream) {
      return source.stream;
    }
    throw new Error(
      `[FinalAcquirer] Le flux final n'a pas encore été injecté par le canvas ` +
      `de régie — sélectionnez une source à l'antenne avant d'utiliser "Flux final" dans une scène.`
    );
  }

  /**
   * Ne stoppe PAS les tracks — le flux appartient au canvas de compositing,
   * pas au consommateur qui l'a emprunté pour une scène.
   */
  release(_source: Source): void {
    // Intentionnellement vide.
  }
}
